
import React from "react";
import "./About.css";
import Footer from "./Footer";
import img1 from "./images/img1.png";
export default function About() {
  return (
    <div className="about-page" dir="rtl">

      {/* =====================================================
          HERO
      ===================================================== */}

      <div className="about-hero">

        <div className="about-overlay">

          <span className="about-badge">
            נצר הובלות ומנופים בע״מ
          </span>

          <h1>
            אודותינו
          </h1>

          <p>
            מקצועיות, ניסיון ושירות אישי בכל הובלה והרמה
          </p>

        </div>

      </div>



      {/* =====================================================
          ABOUT CONTENT
      ===================================================== */}

      <section className="about-content-section">

        <div className="about-content">

          {/* תמונה */}

          <div className="about-images">

            <img
              src={img1}
              alt="נצר הובלות ומנופים בע״מ"
            />

          </div>


          {/* טקסט */}

          <div className="text1">

            <h3>
         פתרונות מקצועיים להובלה, הרמה ושינוע עבור לקוחות פרטיים, עסקים, חברות, קבלנים, יזמים, מפעלים, מוסדות וארגונים בכל רחבי הארץ !
            </h3>

            <p>
       נצר הובלות ומנופים בע״מ מספקת מגוון רחב של שירותי הובלה, מנופים, הרמות ושינוע עבור לקוחות פרטיים, עסקים, חברות, קבלנים, יזמים, מפעלים, מוסדות וארגונים בכל רחבי הארץ.
            </p>

            <p>
     אנו מתמחים בהובלות מיוחדות ובהובלת מטענים וציוד במגוון גדלים ומשקלים, לרבות הובלת ציוד כבד, הובלת חומרי בניין, הובלת מכולות, הובלת עצים, הובלת גנרטורים תעשייתיים כבדים, הובלת מכונות וציוד תעשייתי, הובלת קרוואנים, מיגוניות וממ״דים ניידים, העברת מבנים ושירותי שינוע והרמה בהתאם לצורכי הפרויקט.
            </p>

            <p>
      בנוסף, אנו מספקים שירותי מנוף והשכרת מנופים למגוון מטרות, לרבות השכרת מנוף סל, השכרת מנוף זרוע, מנוף סל להרמת אדם, השכרת סל הרמה, שירותי הרמה, העמסה ופריקה באמצעות מנוף ושירותי שינוע של ציוד ומטענים.
            </p>

            <p>
       אנו מספקים גם פתרונות להובלה והרמה של זכוכית, לרבות הובלה והרמה של לוחות זכוכית באמצעות מערכות הרמה בוואקום, בהתאם לגודל הזכוכית, למשקלה, למיקום העבודה ולתנאי הגישה באתר.
            </p>

            <p>
      השירותים שלנו מתאימים למגוון רחב של לקוחות ופרויקטים – החל מהובלות פרטיות ועבודות נקודתיות ועד פרויקטים מסחריים, תעשייתיים ובנייה מורכבת. אנו עובדים עם קבלנים, חברות בנייה, מפעלים, מחסנים, בעלי עסקים, מתקינים, אנשי מקצוע ולקוחות פרטיים.
            </p>


     <p>
      הצוות שלנו פועל במקצועיות, באחריות ובדגש על תכנון נכון, התאמת אמצעי ההובלה וההרמה למשימה, שמירה על הציוד ומתן שירות אישי, אמין וזמין לאורך כל תהליך העבודה.
            </p>



     <p>
      אנו מאמינים שכל עבודה דורשת פתרון המותאם באופן מדויק לצורכי הלקוח ולתנאים בשטח. לכן אנו מתחילים בהבנת הדרישות, בוחנים את סוג המטען, משקלו, מידותיו, תנאי הגישה ונקודות האיסוף והפריקה, ובהתאם לכך מתכננים את אופן ביצוע העבודה.
            </p>



                 <p>
  בפרויקטים שבהם נדרש שילוב בין הובלה, הרמה ושינוע, אנו יכולים לספק פתרון משולב המאפשר לרכז את העבודה תחת גורם מקצועי אחד ולייעל את תהליך ההובלה והפריקה.
            </p>




     <p>
נצר הובלות ומנופים בע״מ מעניקה שירות בפריסה רחבה ברחבי הארץ, ומתאימה את הפתרון למיקום העבודה, לסוג המטען, למורכבות המשימה ולדרישות הפרויקט.
            </p>




   <p>
   המטרה שלנו היא להעניק לכל לקוח שירות מקצועי, מסודר ואמין, החל משלב התכנון והתיאום ועד להשלמת ההובלה, ההרמה או השינוע.
            </p>







            <div className="about-services">

              <div className="about-service-item">
                <span>✓</span>
                הובלות מיוחדות
              </div>

              <div className="about-service-item">
                <span>✓</span>
                השכרת מנופים
              </div>

              <div className="about-service-item">
                <span>✓</span>
                הרמות ושינוע
              </div>

              <div className="about-service-item">
                <span>✓</span>
                הובלת ציוד כבד
              </div>

            </div>

            <p className="about-final-text">
              נשמח לעמוד לרשותכם ולהעניק לכם שירות מקצועי,
              אדיב ואמין עם פתרון שמתאים בדיוק לצורך שלכם.
            </p>

          </div>

        </div>

      </section>





      {/* =====================================================
          CONTACT
      ===================================================== */}


    </div>
  );
}